import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DomainManagementTableContainer from '../domain-management/domain-management-table-container';

import { fetchUnclaimedDomainsIfNeeded } from '../actions/unclaimed-domains-action-creators';
import { openWhoisModal } from '../../common/actions/modal-action-creators';

import {
    unclaimedDomainsWithCountsIsLoadingSelector,
    unclaimedTotalItemsSelector,
} from '../../common/selectors/unclaimed-domains-with-counts-selectors';
import { discoveredParentDomainsTableDataSelector } from './discovered-domains-selectors';

import {
    domainNameColumn,
    registrantColumn,
    registrantEmailColumn,
    mxExistsColumn,
    dateDiscoveredColumn,
    whoIsColumn
} from '../constants/column-definitions';
import {
    DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED,
    DOMAIN_HIERARCHY_PARENT
} from '../../common/constants/definitions';

const columnDefs = [
    domainNameColumn,
    registrantColumn,
    registrantEmailColumn,
    mxExistsColumn,
    dateDiscoveredColumn,
    whoIsColumn
];

export class DiscoveredDomainsParentTableContainer extends Component{

    componentDidMount(){
        const { fetchUnclaimedDomainsIfNeeded } = this.props;

        fetchUnclaimedDomainsIfNeeded();
    }

    handleOpenWhoisModal = ( { domainName } ) => this.props.openWhoisModal( domainName );

    render(){
        const { data, isLoading, totalItemCount } = this.props;

        return (
            <DomainManagementTableContainer
                columnDefs={columnDefs}
                data={data}
                handleViewButtonAction={this.handleOpenWhoisModal}
                selectedDomainFilter={DOMAIN_HIERARCHY_PARENT}
                isLoading={isLoading}
                totalItemCount={ totalItemCount}
                type={DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        data: discoveredParentDomainsTableDataSelector( state ),
        isLoading: unclaimedDomainsWithCountsIsLoadingSelector( state ),
        totalItemCount: unclaimedTotalItemsSelector( state ),
    };
};

const mapDispatchToProps = {
    fetchUnclaimedDomainsIfNeeded,
    openWhoisModal,
};

DiscoveredDomainsParentTableContainer.propTypes = {
    data: PropTypes.array.isRequired,
    fetchUnclaimedDomainsIfNeeded: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    openWhoisModal: PropTypes.func.isRequired,
    totalItemCount: PropTypes.number
};

export default connect( mapStateToProps, mapDispatchToProps )( DiscoveredDomainsParentTableContainer );
